import React from "react";

export default function Side({ setTab, tab }) {
  return (
    <>
      <div className="layoutSide">
        <div
          className={"layoutSide__btn " + (tab === "start" ? "active" : "")}
          onClick={() => setTab("start")}
        >
          How to start?
        </div>
        <div
          className={"layoutSide__btn " + (tab === "network" ? "active" : "")}
          onClick={() => setTab("network")}
        >
          Network setup
        </div>
        <div
          className={
            "layoutSide__btn " + (tab === "invoice-creation" ? "active" : "")
          }
          onClick={() => setTab("invoice-creation")}
        >
          Invoice creation
        </div>
        <div
          className={
            "layoutSide__btn " + (tab === "invoice-payment" ? "active" : "")
          }
          onClick={() => setTab("invoice-payment")}
        >
          Invoice payment
        </div>
        <div
          className={"layoutSide__btn " + (tab === "graphs" ? "active" : "")}
          onClick={() => setTab("graphs")}
        >
          Graphs
        </div>
      </div>
    </>
  );
}
